/* eslint-disable class-methods-use-this */
/* eslint-disable no-param-reassign */
class MenuController {
  constructor(target:HTMLElement, button:HTMLElement) {
    // Set initial menu value
    target.dataset.active = 'false';

    // Add event listener to button
    button.addEventListener('click', () => {
      this.toggleMenu(target, button);
    });
  }

  toggleMenu(target:HTMLElement, button: HTMLElement) {
    const toggle = this.getToggle(target);
    target.dataset.active = toggle;
    button.dataset.active = toggle;
  }

  getToggle(target:HTMLElement) {
    let dataActive:any = target.dataset.active === 'true';
    dataActive = `${!dataActive}`;

    return dataActive;
  }
}

export default MenuController;
